import React, { useEffect } from "react";
import { Modal, Descriptions, Divider, Button, Spin } from "antd";
import { VideoCameraAddOutlined, LoadingOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { ViewVrItem } from "../../Redux/Actions/homeVrActions";
import "./viewHomeVR.css";

const HomeVrViewModal = ({ visible, vrData, onClose }) => {
  const dispatch = useDispatch();

  const { vrItem, loading, error } = useSelector((s) => s.vrHome || {});

  useEffect(() => {
    if (visible && vrData?._id) {
      dispatch(ViewVrItem(vrData._id));
    }
  }, [visible, vrData?._id, dispatch]);

  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const data = vrItem || vrData;

  const renderBody = () => {
    if (loading) {
      return (
        <div className="view-hb-loader">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 36, color: "#070C18" }} spin />} />
          <p className="view-hb-loader-text">Loading VR details…</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="view-hb-error">
          <p>Failed to load VR details. Please try again.</p>
        </div>
      );
    }

    return (
      <>
        {/* VR Information */}
        <div className="view-hb-card">
          <h3 className="view-hb-card-header">VR Information</h3>
          <div className="view-hb-grid">
            <Descriptions column={2} bordered size="small">
              <Descriptions.Item label="Project Name">
                <span className="view-hb-value view-hb-type-badge">
                  {data?.project_data?.project_name || "N/A"}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="Project ID">
                <span style={{ fontSize: "12px", fontFamily: "monospace", color: "#6b7280" }}>
                  {data?.project?.project_id || "—"}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="Project Ranking">
                <span className="view-hb-value">{data?.project_ranking ?? 0}</span>
              </Descriptions.Item>
              <Descriptions.Item label="Status">
                <span className={`view-hb-status ${data?.is_deleted ? "view-hb-status-deleted" : "view-hb-status-active"}`}>
                  {data?.is_deleted ? "Deleted" : "Active"}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="Created">
                {formatDate(data?.created_at)}
              </Descriptions.Item>
              <Descriptions.Item label="Updated">
                {formatDate(data?.updated_at)}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>

        <Divider className="view-hb-divider" />

        {/* Cover Photo */}
        <div className="view-hb-card">
          <h3 className="view-hb-card-header">Project Cover Photo</h3>
          <div className="view-hb-image-container">
            {data?.project?.cover_photo ? (
              <img
                src={data.project?.cover_photo}
                alt="Cover"
                className="view-hb-image"
              />
            ) : (
              <div className="view-hb-no-image">
                <VideoCameraAddOutlined style={{ fontSize: 48, color: "#ccc" }} />
                <p>No cover photo available</p>
              </div>
            )}
          </div>
        </div>

        <Divider className="view-hb-divider" />

        {/* Location */}
        <div className="view-hb-card">
          <h3 className="view-hb-card-header">Location Details</h3>
          <div className="view-hb-grid">
            <Descriptions column={2} bordered size="small">
              <Descriptions.Item label="Country">
                {data?.country?.country_name || data?.country?.name || "—"}
              </Descriptions.Item>
              <Descriptions.Item label="State">
                {data?.state?.state_name || data?.state?.name || "—"}
              </Descriptions.Item>
              <Descriptions.Item label="City">
                {data?.city?.city_name || data?.city?.name || "—"}
              </Descriptions.Item>
            </Descriptions>
          </div>
        </div>

        {/* Meta Data — only if exists */}
        {data?.meta_data?.length > 0 && (
          <>
            <Divider className="view-hb-divider" />
            <div className="view-hb-card">
              <h3 className="view-hb-card-header">Meta Data</h3>
              <div className="view-hb-grid">
                <Descriptions column={2} bordered size="small">
                  {data.meta_data.map((meta, index) => (
                    <Descriptions.Item key={index} label={meta.key || `Key ${index + 1}`}>
                      {meta.value || "—"}
                    </Descriptions.Item>
                  ))}
                </Descriptions>
              </div>
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <Modal
      title={
        <div className="view-hb-modal-header-content">
          <VideoCameraAddOutlined className="view-hb-modal-header-icon" style={{ color: "white" }} />
          <span style={{ color: "white" }}>HOME VR DETAILS</span>
        </div>
      }
      open={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
      width={800}
      className="view-hb-modal-override"
      styles={{
        header: {
          background: "#070C18",
          borderRadius: "12px 12px 0 0",
          padding: "20px 24px",
          borderBottom: "none",
        },
        body: {
          padding: "24px",
          background: "#fafafa",
        },
      }}
    >
      <div className="view-hb-modal-content">

        {renderBody()}

        <Divider className="view-hb-divider" />

        <div className="view-hb-actions">
          <Button
            size="large"
            onClick={onClose}
            style={{ background: "#070C18" }}
            className="view-hb-btn view-hb-btn-primary"
          >
            Close
          </Button>
        </div>

      </div>
    </Modal>
  );
};

export default HomeVrViewModal;